"use client";

import { motion } from "motion/react";
import { CustomButton } from "@/components/ui/custom-button";
import { LTIFormModal as LTIModal } from "@/components/modals/FormModal";
import { LMSBeam } from "./lms_beam";
import { useState } from "react";

export function LMSExplanation() {
	const [isLTIModalOpen, setIsLTIModalOpen] = useState(false);

	return (
		<section className="flex justify-center" aria-label="LMS integration introduction">
			<div className="flex w-full flex-col">
				{/* Integrations Header */}
				<motion.div
					initial={{ opacity: 0, y: 60 }}
					animate={{ opacity: 1, y: 0 }}
					className="-mt-12 flex flex-col items-center justify-center space-x-2"
				>
					<h1 className="text-lg font-bold">
						Integrations Guide
					</h1>
					<motion.p
						initial={{ opacity: 0, y: 60 }}
						animate={{ opacity: 1, y: 0 }}
						className="mt-3 px-4 text-center text-base text-gray-700 md:text-lg"
					>
						No complex integrations needed - just a simple solution that works alongside any LMS with LTI 1.3.
					</motion.p>
				<motion.div
					initial={{ opacity: 0, y: 60 }}
					animate={{ opacity: 1, y: 0 }}
					className="mt-4 flex justify-center gap-3"
				>
					<CustomButton 
						variant="outline" 
						size="md"
						onClick={() => setIsLTIModalOpen(true)}
						aria-label="Request our LTI 1.3 specification"
					>
						Request the guide
					</CustomButton>
					<CustomButton 
						variant="primary" 
						size="md"
						onClick={() => window.location.href = '/who-we-help/universities#learning-carousel'}
						aria-label="See how StudyStash works"
					>
						See how it works
					</CustomButton>
				</motion.div>
				</motion.div>
				
				{/* Hero Section */}
				<div className="flex flex-col items-center justify-center pt-2">
					<motion.div
						initial={{ opacity: 0, y: 60 }}
						animate={{ opacity: 1, y: 0 }}
						className="mt-4 w-full px-3 md:px-8"
					>
						<LMSBeam />
					</motion.div>
				</div>
			</div>
			<LTIModal open={isLTIModalOpen} onOpenChange={setIsLTIModalOpen} />
		</section>
	);
}
